import './FollowUpBar.css';
import React, { useState } from 'react';

function FollowUpBar({ onSubmit }) {
    const [query, setQuery] = useState(''); 

    const handleSubmit = (e) => {
        e.preventDefault();
        if (query.trim()) {
            onSubmit(query);
            setQuery(''); // Clear the input after submission
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          handleSubmit(e);
        }
    };

    return (
        <div className="follow-up-bar-container">   
            <form className="follow-up-bar" onSubmit={handleSubmit}>
                <textarea 
                    className="follow-up-bar-textarea" 
                    placeholder="Modify your travel plan..."
                    onChange={(e) => setQuery(e.target.value)}
                    onKeyDown={handleKeyDown}
                >
                </textarea>
                <button type="submit">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="20">
                        <path d="M13 5.41V21h-2V5.41L5.41 11 4 9.59 12 1.59l8 8L18.59 11 13 5.41z"/>
                    </svg>
                </button>
            </form>
        </div>
    );
}

export default FollowUpBar;